<div fxLayout="column" fxLayoutGap="10px">
	<rpshared-unavailable-day
		[formControl]="control"
		rpsharedRemoveHost
	></rpshared-unavailable-day>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="primary">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="group.invalid"
			color="primary"
			[mat-dialog-close]="group"
		>
			Save
		</button>
	</div>
</div>
